function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9998 9.37576e-05C25.6757 9.37576e-05 17.5836 3.06566 11.2766 8.27023L3.62691 0.620574C3.01784 0.0141013 2.10528 -0.167477 1.31204 0.161439C0.518796 0.489837 0 1.26336 0 2.12508V20.5413C0 21.7143 0.951991 22.6663 2.12499 22.6663H20.5417C21.4029 22.6663 22.1765 22.148 22.5054 21.3548C22.8338 20.5615 22.6527 19.649 22.0431 19.0399L15.3029 12.2966C20.5417 8.12289 27.1714 5.66639 33.9998 5.66639C49.6229 5.66639 62.3334 18.3769 62.3334 33.9999C62.3334 49.6224 49.6229 62.333 33.9998 62.333C26.4379 62.333 19.3236 59.3836 13.9712 54.0286C12.8636 52.9204 11.0727 52.9204 9.96504 54.0286C8.85689 55.1362 8.85689 56.9271 9.96504 58.0347C16.3883 64.4605 24.9251 67.9998 33.9998 67.9998C52.7481 67.9998 67.9997 52.7477 67.9997 33.9999C67.9997 15.2517 52.7481 9.37576e-05 33.9998 9.37576e-05Z",
  fill: "black"
});

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.41dd173b.svg";
export { ForwardRef as ReactComponent };